export default function reducer(state={
    auth: false,
    userData: null,
    loginProgress:false,
    loginSuccess:false,
    error: null,
    userCompanies: null,
    selectedCompany: null,
    currentSettings: null
}, action){

    switch (action.type) {
        case "LOGIN_STATE_CHANGED":
            return {...state, auth: action.payload.auth, userData: action.payload.data}
        case "USER_LOGIN":
            return {...state, loginProgress: true}
        case "USER_LOGIN_REJECTED":
            return {...state, loginProgress:false, loginError: action.payload}
        case "USER_LOGIN_FULFILLED":
            return {
                ...state,
                loginProgress: false,
                loginSuccess: true
            }  
        case "SELECT_COMPANY":
            return {...state, selectedCompany: action.payload.company, currentSettings: action.payload.settings}    
        case "GET_USER_COMPANIES":
            return {...state, fetching: true}
        case "GET_USER_COMPANIES_REJECTED":
            return {...state, fetching:false, error: action.payload}
        case "GET_USER_COMPANIES_FULFILLED":
            return {
                ...state,
                fetching: false,
                fetched: true,
                userCompanies: action.payload
            }          
        case "UPDATE_USER_SETTINGS":
            return {...state, currentSettings:action.payload}
        case "UPLOAD_USER_SETTINGS":
            return {...state}
        case "UPLOAD_USER_SETTINGS_REJECTED":
            return {...state, error:action.payload}            
        default:   
        return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/user.js